import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function useAssets() {
    const { t } = useTranslation('accountTermination');
    const { data, status } = useQuery({
        ...queries.user.assets(),
        retry: 1,
    });
    const isStamp = data?.rewardType === 'STAMP';
    const toast = useToast();
    useEffect(() => {
        if (status === 'error') {
            toast.error(t('toast.assetError'));
        }
    }, [status]);
    return { isStamp, data };
}

export default useAssets;
